import { Link } from "react-router-dom";

// EditSaveBar — sticky save bar at the bottom of the form.
// Substrate: design/editRealty.html lines 868-881 — `<nav class="ap-nav">`.
//
// Status label reads:
//   * saving  → "Збереження…"  pulsing dot
//   * success → "Збережено"     solid dot
//   * error   → save error message inline
//   * dirty   → "Є незбережені зміни"
//   * clean   → "Усі зміни збережено" + optional updated_at context
//
// Clean: Save disabled; return action to Property detail.
// Dirty: Save enabled; unsaved status visible/accessible.

const formatRelativeMinutes = (iso) => {
  if (!iso) return null;
  const updated = new Date(iso).getTime();
  if (!Number.isFinite(updated)) return null;
  const diffMs = Date.now() - updated;
  if (diffMs < 0) return "щойно";
  const minutes = Math.floor(diffMs / 60000);
  if (minutes < 1) return "щойно";
  if (minutes < 60) return `${minutes} хв тому`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} год тому`;
  const days = Math.floor(hours / 24);
  return `${days} дн тому`;
};

function EditSaveBar({
  cancelHref,
  saveState,
  saveError,
  updatedAt,
  isDirty = false,
}) {
  const isSaving = saveState === "saving";
  const canSave = isDirty && !isSaving;

  let statusLabel;
  let statusClass = "ap-save-status";
  if (isSaving) {
    statusLabel = "Збереження…";
  } else if (saveState === "success") {
    statusLabel = "Збережено";
  } else if (saveState === "error") {
    statusLabel = saveError || "Не вдалося зберегти";
  } else if (isDirty) {
    statusLabel = "Є незбережені зміни";
    statusClass += " is-dirty";
  } else {
    const relative = formatRelativeMinutes(updatedAt);
    statusLabel = relative
      ? `Усі зміни збережено · останнє оновлення: ${relative}`
      : "Усі зміни збережено";
  }

  return (
    <nav className="ap-nav" aria-label="Зберегти зміни">
      {isDirty ? (
        <Link to={cancelHref} className="action-btn">
          <i className="fa-solid fa-xmark" aria-hidden="true" />
          Скасувати
        </Link>
      ) : (
        <Link
          to={cancelHref}
          className="action-btn"
          data-testid="edit-savebar-return"
        >
          <i className="fa-solid fa-arrow-left" aria-hidden="true" />
          До оголошення
        </Link>
      )}
      <span className="ap-nav__step">
        <span
          className={statusClass}
          role="status"
          aria-live="polite"
          data-save-state={saveState}
          data-dirty={isDirty ? "true" : "false"}
        >
          <i className="fa-solid fa-circle" aria-hidden="true" />
          <span className="ap-save-status__label">{statusLabel}</span>
        </span>
      </span>
      <button
        type="submit"
        className="action-btn action-btn--accent"
        disabled={!canSave}
        aria-disabled={!canSave}
        data-testid="edit-savebar-submit"
      >
        <i className="fa-solid fa-floppy-disk" aria-hidden="true" />
        Зберегти зміни
      </button>
    </nav>
  );
}

export default EditSaveBar;
